import DealerListParams from "../../../../../common/services/user/dealer/list/user-dealer-list-params";
import UserOrder from "../../../../../common/types/user-order";
import { DriverListingTaxiCorporationFilter } from "../../../driver/listing/common/types/driver-listing-filter";
import DealerListingFilter, {
  DealerListingActivityStatusFilter,
  DealerListingEmailAddressFilter,
  DealerListingFirstNameFilter,
  DealerListingLastNameFilter,
  DealerListingUserNameFilter,
} from "./types/dealer-listing-filter";
import DealerListingFilterType from "./types/dealer-listing-filter-type";
import DealerListingSortKey from "./types/dealer-listing-sort-key";

const createOrder = (
  sortKey: DealerListingSortKey | null,
): UserOrder | undefined => {
  const definition: Record<DealerListingSortKey, UserOrder> = {
    [DealerListingSortKey.FIRST_NAME_ASC]: UserOrder.FIRST_NAME_ASC,
    [DealerListingSortKey.FIRST_NAME_DESC]: UserOrder.FIRST_NAME_DESC,
    [DealerListingSortKey.LAST_NAME_ASC]: UserOrder.LAST_NAME_ASC,
    [DealerListingSortKey.LAST_NAME_DESC]: UserOrder.LAST_NAME_DESC,
    [DealerListingSortKey.USERNAME_ASC]: UserOrder.USERNAME_ASC,
    [DealerListingSortKey.USERNAME_DESC]: UserOrder.USERNAME_DESC,
  };

  return sortKey ? definition[sortKey] : undefined;
};

const create = (
  page: number,
  pageSize: number,
  filters: DealerListingFilter[],
  sortKey: DealerListingSortKey | null,
): DealerListParams => {
  const statusFilter = filters.find(
    (filter) => filter.type === DealerListingFilterType.ACTIVITY_STATUS,
  )?.value as DealerListingActivityStatusFilter["value"] | undefined;

  return {
    page,
    pageSize,
    order: createOrder(sortKey),
    taxiCorporation: filters.find(
      (filter) => filter.type === DealerListingFilterType.TAXI_CORPORATION,
    )?.value as DriverListingTaxiCorporationFilter["value"] | undefined,
    firstName: filters.find(
      (filter) => filter.type === DealerListingFilterType.FIRST_NAME,
    )?.value as DealerListingFirstNameFilter["value"] | undefined,
    lastName: filters.find(
      (filter) => filter.type === DealerListingFilterType.LAST_NAME,
    )?.value as DealerListingLastNameFilter["value"] | undefined,
    username: filters.find(
      (filter) => filter.type === DealerListingFilterType.USERNAME,
    )?.value as DealerListingUserNameFilter["value"] | undefined,
    email: filters.find(
      (filter) => filter.type === DealerListingFilterType.EMAIL_ADDRESS,
    )?.value as DealerListingEmailAddressFilter["value"] | undefined,
    status: statusFilter,
  };
};

const dealerListingLoadParamsFactory = {
  create,
};

export default dealerListingLoadParamsFactory;
